import script from "./TabByIP.vue?vue&type=script&lang=ts&setup=true"
export * from "./TabByIP.vue?vue&type=script&lang=ts&setup=true"

import "./TabByIP.vue?vue&type=style&index=0&id=6433ce35&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6433ce35"]])

export default __exports__